import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import Icon from '../Icon';

import { COLORS } from '../../constants/styles';
import styles from './group.styl';

const GroupAvatar = ({
  active,
  iconSize,
  iconName,
  width,
  height,
  className,
}) => (
  <div
    className={className}
    style={{
      height,
      width,
    }}
    styleName={classNames('image', { 'image--bordered': active })}
  >
    <Icon name={iconName} size={iconSize} style={{ fill: COLORS.white }} />
  </div>
);

GroupAvatar.propTypes = {
  active: PropTypes.bool,
  iconSize: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  iconName: PropTypes.string.isRequired,
  className: PropTypes.string,
};

GroupAvatar.defaultProps = {
  className: '',
  active: false,
  iconSize: 20,
  width: 32,
  height: 32,
};

export default CSSModules(GroupAvatar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Avatar/GroupAvatar.jsx